import { useQuery } from "react-query";
import http from "infra/http";

function useGoogleMapApiKey(enabled = true) {
  return useQuery(["/v1/google-maps-api-key"], async () => {
    const { data } = await http.get<{ apiKey: string }>(
      "/v1/google-maps-api-key"
    );

    return data.apiKey;
  },
  {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled,
  }
  );
}

export default useGoogleMapApiKey;
